'use strict';

import React, { PropTypes } from 'react';
import ClassNameMixin from '../mixins/ClassNameMixin';
import ContextMenuActionCreators from '../actions/ContextMenuActionCreators';
import PureRenderMixin from '../mixins/PureRenderMixin';

import './ContextMenu.less';

const MENU_MARGIN = 8;

const Separator = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  statics: {
    IS_SEPARATOR: true
  },

  className: 'ContextMenu-separator',

  render: function () {
    return (
      <div className={this.getClassName()} />
    );
  }
});

const ContextMenu = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  statics: {
    Separator: Separator
  },

  propTypes: {
    anchorRect: PropTypes.shape({
      top: PropTypes.number.isRequired,
      right: PropTypes.number.isRequired,
      bottom: PropTypes.number.isRequired,
      left: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired
    }).isRequired
  },

  className: 'ContextMenu',

  getDefaultProps: function () {
    return {
      theme: 'dark'
    };
  },

  getCSSModifiers: function () {
    return [this.props.theme];
  },

  getMenuRect() {
    var anchorRect = this.props.anchorRect,
        menuRect;

    menuRect = {
      right: window.innerWidth - anchorRect.right
    };

    if (anchorRect.top + anchorRect.height / 2 < window.innerHeight / 2) {
      menuRect.top = anchorRect.bottom + MENU_MARGIN;
    } else {
      menuRect.bottom = window.innerHeight - anchorRect.top + MENU_MARGIN;
    }

    return menuRect;
  },

  render: function () {
    var style = this.getMenuRect();

    return (
      <div className={this.getClassName()}
           style={style}>
        {React.Children.map(this.props.children, this.renderContextMenuItem)}
      </div>
    );
  },

  renderContextMenuItem: function (item, index) {
    if (!item) {
      return;
    }

    if (item.type.IS_SEPARATOR) {
      return item;
    }

    return (
      <div className='ContextMenu-item'
           onClick={this.handleContextMenuItemClick}
           key={index}>
        {item}
      </div>
    );
  },

  handleContextMenuItemClick: function () {
    ContextMenuActionCreators.hideContextMenu();
  }
});

export default ContextMenu;


/** WEBPACK FOOTER **
 ** ./molecules/ContextMenu.jsx
 **/